<template>
  <ScrollContainer
    class="SettingsProfilePage"
    viewport="Mobile"
    includeViewportPadding="bottom"
  >
    <div class="SettingsProfilePage__content">
      <MembershipView v-if="!isMobileNativePromotionalSubscriptionEnabled" />

      <EditUserView />

      <UIText
        class="SettingsProfilePage__deleteAccountButton"
        tag="button"
        size="Small"
        weight="Medium"
        @click="handleDeleteAccountClick"
      >
        Delete account
      </UIText>

      <section class="SettingsProfilePage__support">
        <UIText
          class="SettingsProfilePage__signOutLink"
          tag="a"
          size="2XSmall"
          weight="Medium"
          @click="signOut()"
        >
          Sign out
        </UIText>

        <div class="SettingsProfilePage__supportDivider" />

        <UIText
          class="SettingsProfilePage__supportLink"
          tag="a"
          href="mailto:support@era.app"
          size="2XSmall"
          weight="Medium"
        >
          support@era.app
        </UIText>
      </section>

      <section class="SettingsProfilePage__debug">
        <UIText
          size="2XSmall"
          weight="Medium"
        >
          {{ currentUser?.UserId }}
        </UIText>
      </section>
    </div>
  </ScrollContainer>

  <Teleport :to="PortalId.Body">
    <Transition>
      <DeleteAccountModalView
        v-if="isDeleteAccountModalOpen"
        @close="handleModalClose"
      />
    </Transition>
  </Teleport>
</template>

<script lang="ts" setup>
import { PortalId } from "@cosine/components/Portal.types";
import ScrollContainer from "@cosine/components/ScrollContainer.vue";
import UIText from "@cosine/components/UIText.vue";
import useFullSeoMeta from "@cosine/composables/useFullSeoMeta";
import useAuthStore from "@cosine/stores/useAuthStore";
import useSubscriptionStore from "@cosine/stores/useSubscriptionStore";
import DeleteAccountModalView from "@cosine/views/DeleteAccountModalView.vue";
import EditUserView from "@cosine/views/EditUserView.vue";
import MembershipView from "@cosine/views/MembershipView.vue";
import { storeToRefs } from "pinia";
import { ref } from "vue";

useFullSeoMeta({
  title: "Profile",
});

const isDeleteAccountModalOpen = ref(false);

const {
  signOut,
} = useAuthStore();

const {
  currentUser,
} = useAuthStore();

const subscriptionStore = useSubscriptionStore();
const {
  isMobileNativePromotionalSubscriptionEnabled,
} = storeToRefs(subscriptionStore);

function handleDeleteAccountClick () {
  isDeleteAccountModalOpen.value = true;
}

function handleModalClose () {
  isDeleteAccountModalOpen.value = false;
}
</script>

<style lang="scss" scoped>
.SettingsProfilePage {
  height: 100%;
}

.SettingsProfilePage__content {
  display: grid;
  grid: auto min-content min-content / auto;
  height: 100%;
}

.SettingsProfilePage__deleteAccountButton {
  margin: 16px 0;
  color: var(--colorNegative);
  text-align: center;
}

.SettingsProfilePage__support {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  margin-top: 16px;

  text-align: center;
}

.SettingsProfilePage__supportLink {
  text-decoration: none;
}

.SettingsProfilePage__signOutLink {
  cursor: pointer;
}

.SettingsProfilePage__supportDivider {
  width: 1px;
  height: 80%;
  background-color: var(--colorSwissAlphaBlack300);
}

.SettingsProfilePage__debug {
  padding: 8px var(--layoutMargin) var(--viewportPaddingBottom);
  color: var(--colorSwissAlphaBlack500);
  text-align: center;
}
</style>
